import type { FilterConfigGroupItem } from '../FilterConfigTypes';

export const groupItems: Array<FilterConfigGroupItem> = [
  {
    groupLabel: 'NPI Attributes',
    ordinalPosition: 2,
    tooltip:
      'The NPI Attributes section provides a suite of tools to refine your audience targeting based on specific attributes associated with healthcare professionals. These attributes cover various aspects such as demographics, education, specialization, and location. By utilizing the NPI Attributes section, you can tailor your outreach efforts to target healthcare professionals who match your desired criteria, ensuring your campaigns are highly relevant and effective.',
    filtersInGroup: [
      { name: 'gender_filter', index: 1 },
      { name: 'age_range_filter', index: 2 },
      { name: 'medical_school_filter', index: 3 },
      { name: 'graduation_year_filter', index: 4 },
      { name: 'profession_and_speciality_subgroup', index: 5 },
      { name: 'years_practiced_range_filter', index: 6 },
      { name: 'state_name_filter', index: 7 },
      { name: 'net_worth_filter', index: 8 },
      { name: 'number_of_patients_range_filter', index: 9 },
      { name: 'facility_name_filter', index: 10 },
      { name: 'npi_list_name_filter', index: 11 },
      { name: 'npi_zipcode_filter', index: 12 },
      { name: 'npi_dma_filter', index: 13 },
    ],
    advancedGroup: false,
  },
  {
    groupLabel: 'Patient Attributes',
    ordinalPosition: 3,
    tooltip:
      'The Patient Attributes section provides filters to refine audience targeting based on specific characteristics related to patients. These attributes encompass various factors such as demographics, medical history, and clinical conditions. By utilizing the Patient Attributes section, users can tailor their outreach efforts to target healthcare professionals who treat patients with specific characteristics or conditions.',
    filtersInGroup: [
      { name: 'patient_gender_filter', index: 1 },
      { name: 'patient_age_range_filter', index: 2 },
      { name: 'patient_insurance_provider_name_filter', index: 3 },
      { name: 'patient_insurance_type_filter', index: 4 },
      { name: 'patient_state_name_filter', index: 5 },
      { name: 'patient_facility_name_filter', index: 6 },
    ],
    advancedGroup: false,
  },
  {
    groupLabel: 'Contextual',
    ordinalPosition: 5,
    filtersInGroup: [
      { name: 'iab_subgroup', index: 1 },
      { name: 'mesh_subgroup', index: 4 },
      { name: 'contextual_topic_descriptor_filter', index: 6 },
      { name: 'contextual_concept_descriptor_filter', index: 7 },
    ],
    requiredPermissions: ['Moments', 'IBHealth'],
    advancedGroup: false,
  },
  {
    groupLabel: 'Clinical',
    ordinalPosition: 4,
    tooltip:
      'The Clinical section provides a range of filters designed to refine audience targeting based on clinical factors related to healthcare professionals. These filters allow you to target individuals based on their prescription behavior, diagnostic practices, procedures performed, and related clinical activities. By utilizing the Clinical section, you can tailor your outreach efforts to reach healthcare professionals who have demonstrated specific clinical behaviors or expertise. This approach ensures that your messaging is highly relevant and resonates with the clinical interests and practices of your target audience.',
    filtersInGroup: [
      { name: 'prescriptions_subgroup', index: 1 },
      { name: 'prescribing_behavior_subgroup', index: 2 },
      { name: 'diagnoses_subgroup', index: 3 },
      { name: 'procedures_subgroup', index: 4 },
    ],
    advancedGroup: false,
  },
  {
    groupLabel: 'Engagement',
    ordinalPosition: 1,
    tooltip:
      'The Engagement section provides a comprehensive suite of filters designed to refine audience targeting based on various digital interactions and activities of healthcare professionals. These filters encompass data collected from website visits, search queries, email interactions, social media engagements, and media exposures. By utilizing the Engagement section, you can tailor your outreach efforts to reach healthcare professionals who have demonstrated specific digital behaviors or engagements. This approach ensures that your messaging is highly relevant and resonates with the digital habits and preferences of your target audience.',
    filtersInGroup: [
      { name: 'site_subgroup', index: 1 },
      { name: 'search_subgroup', index: 2 },
      { name: 'email_subgroup', index: 3 },
      { name: 'social_subgroup', index: 4 },
      { name: 'media_subgroup', index: 5 },
    ],
    advancedGroup: false,
  },
];
